export default "__VITE_ASSET__CoaLvTLP__";